module.exports = __webpack_public_path__ + "media/scholarship_winners/trophys_175x108-d5639966.png";